import { useRef, useState } from 'react';
import { Overlay, Tooltip } from 'react-bootstrap';

export const ElipsisTooltip = ({
  children,
  title,
  alwaysShow = false,
  hideoverlay = false,
  className = '',
  placement = 'top',
  container = document.body,
  stayOpenOnHover = false, 
  hoverDelay = 150,
}) => {
  const [show, setShow] = useState(false);
  const tooltipTarget = useRef(null);
  const hideTimeoutRef = useRef(null);

  const handleMouseEnter = (e) => {
    if (e.target.offsetWidth < e.target.scrollWidth) {
      setShow(true);
    }
    if (alwaysShow) {
      setShow(true);
    }
  };

  const handleMouseLeave = () => {
    if (stayOpenOnHover) {
      hideTimeoutRef.current = setTimeout(() => setShow(false), hoverDelay);
    } else {
      setShow(false);
    }
  };

  const tooltipEvents = stayOpenOnHover
    ? {
        onMouseEnter: () => {
          if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
          setShow(true);
        },
        onMouseLeave: () => setShow(false),
      }
    : {};

  return (
    <>
      {!hideoverlay ? (
        <Overlay
          target={tooltipTarget.current}
          show={show}
          placement={placement}
          container={container}
          popperConfig={{
            modifiers: [
              {
                name: 'flip',
                enabled: true,
                options: {
                  fallbackPlacements: ['top', 'bottom', 'left', 'right'],
                },
              },
            ],
          }}>
          {(props) => (
            <Tooltip className={className} {...props} {...tooltipEvents}>
              {title}
            </Tooltip>
          )}
        </Overlay>
      ) : (
        <Tooltip
          placement={placement}
          target={tooltipTarget.current}
          className={show ? 'show' : ''}
          show={show}
          container={container}
          popperConfig={{
            modifiers: [
              {
                name: 'flip',
                enabled: true,
                options: {
                  fallbackPlacements: ['top', 'bottom', 'left', 'right'],
                },
              },
            ],
          }}
          {...tooltipEvents}>
          {title}
        </Tooltip>
      )}
      {children({
        ref: tooltipTarget,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
      })}
    </>
  );
};
